import { abortIfNotPermitted, abortIfRequiresSubscription } from '../utils';

export default [
    {
        path: '/',
        component: () =>
            import('@js/franchise_component/marketplace/marketplace_new.vue'),
    },
    {
        path: '/faq',
        component: () => import('@js/franchise_component/marketplace/faq.vue'),
    },
];



// WEBPACK FOOTER //
// ./resources/assets/js/router/route-components/marketplace.js